/*
 * @Descripttion: 每次登录系统展示弹窗
 * @Author: yang chenglin
 * @LastEditors: yang chenglin
 */
import React, { useEffect, useState } from 'react';
import { Checkbox, Dialog } from '@alifd/next';
import styles from './index.module.scss';
import Cookie from 'js-cookie';

export default function () {
  // const BASEBOOL = Cookie.get('LZDYLogin') === 'true' ?? false;
  const BASEBOOL = true;
  const [item, setDatasource] = useState(BASEBOOL);
  // const [visible, setVisible] = useState(sessionStorage.getItem('LZDYLoginDialogCloseToday') === '1');
  const [visible, setVisible] = useState<boolean>(BASEBOOL);
  const [closeToday, setCloseToday] = useState<boolean>(false);
  const [size, setSize] = useState({ width: 900, height: 600 });

  function setDialogSize(img: HTMLImageElement) {
    // 获取视窗的宽高，用于计算图片的宽高，保持图片比例
    const winWidth = window.innerWidth;
    const winHeight = window.innerHeight;
    // 获取图片的宽高
    const imgWidth = img.width;
    const imgHeight = img.height;
    // 获取图片的宽高比例
    const imgScale = imgWidth / imgHeight;
    // 获取图片的实际宽高
    let realWidth = 0;
    let realHeight = 0;
    // 获取图片的实际宽度
    realWidth = winWidth > imgWidth ? imgWidth : winWidth;
    // 获取图片的实际高度
    realHeight = realWidth / imgScale;
    // 判断图片的实际高度是否大于视窗高度
    if (realHeight > winHeight) {
      // 获取图片的实际高度
      realHeight = winHeight;
      // 获取图片的实际宽度
      realWidth = realHeight * imgScale;
    }
    // 设置图片的宽高
    setSize({ width: realWidth, height: realHeight });
  }

  const loadData = async () => {
    const img = new Image();
    img.src = 'https://img10.360buyimg.com/imgzone/jfs/t1/436278/32/13490/562532/6a0d719aF594bc302/00834b026ce6bf70.png';
    img.onload = () => {
      setDialogSize(img);
      setVisible(true);
    };
  };

  const handleClose = () => {
    // sessionStorage.setItem('LZDYLoginDialogCloseToday', closeToday ? '1' : '0');
    setVisible(false);
    // Cookie.set('LZDYLogin', 'false')
  };

  useEffect(() => {
    loadData();
  }, []);

  if (!item) return null;
  return (
    <Dialog
      v2
      width={size.width}
      height={size.height}
      visible={visible}
      title={false}
      closeable={false}
      centered
      // closeIcon={<i className="iconfont icon-icon4-29" />}
      wrapperClassName={styles['login-dialog-wrapper']}
      animation={{ in: 'zoomIn', out: 'zoomOut' }}
      footerAlign={'center'}
      footerActions={[]}
      closeMode={['close', 'mask', 'esc']}
      footer={false}
      // footer={[
        // <Checkbox key={'closeToday'} value={closeToday} onChange={setCloseToday}>
        //   今日不再弹出
        // </Checkbox>,
      // ]}
      onClose={() => handleClose()}
    >
        <div className={styles['dialog-image-wrap']}>
          <img src='https://img10.360buyimg.com/imgzone/jfs/t1/436278/32/13490/562532/6a0d719aF594bc302/00834b026ce6bf70.png' alt='' />
          <button
            type="button"
            aria-label="关闭"
            className={styles['close-hotspot']}
            onClick={() => handleClose()}
          />
        </div>
    </Dialog>
  );
}
